import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a73a1bcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "targetInfo" }
const _hoisted_2 = { class: "subjectInformation" }
const _hoisted_3 = { class: "detail_all" }
const _hoisted_4 = {
  key: 0,
  class: "cowDetail"
}
const _hoisted_5 = { class: "cell-item title" }
const _hoisted_6 = { class: "cowImgs" }
const _hoisted_7 = {
  key: 2,
  class: "cowDetail otherDetail"
}
const _hoisted_8 = { class: "cell-item title" }
const _hoisted_9 = {
  key: 0,
  class: "cowImgs"
}
const _hoisted_10 = {
  key: 1,
  class: "cowImgs flex"
}
const _hoisted_11 = {
  class: "video",
  controls: "",
  style: {"width":"200px","height":"100px"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "demo-image__preview" }

import { ref, toRef } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TargetInfo',
  props: ["targetInfo", 'ossUrl','cosUrl', 'type', 'farmerInfo'],
  setup(__props) {

const props = __props;

const resultTitle = {
  'NORMAL': '唯一标的',
  'REPEAT': '疑似重复'
}
const otherDetail = {
  '0': '其他照片',
  '1': '视频',
}

const targetInfo = toRef(props, "targetInfo");
const ossUrl = toRef(props, "ossUrl");
const cosUrl = toRef(props, "cosUrl");
const type = toRef(props, "type");
const previewList = ref([]);
const showViewer = ref(false);
const setPicName = (picType: string) => {
  return picType == "FACE"
    ? "正脸:"
    : picType == "NOSE"
      ? "鼻纹:"
      : picType == "LEFT_FACE"
        ? "侧脸:"
        : picType == "RIGHT_FACE"
          ? "右侧脸:"
          : "";
};
const clickImage = (image: string) => {
  previewList.value = [image];
  showViewer.value = true;
};
const getImageUrl = (fileId: any) => {
  return fileId.cloudServiceType === '1' ? ossUrl.value + fileId.url : cosUrl.value + fileId.url;
}


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_descriptions, {
        title: "",
        column: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: "农户姓名",
            width: "24%"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.farmerInfo.farmerName || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, {
            label: "标的编号",
            width: "28%"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(targetInfo).targetNo || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, {
            label: "位置",
            width: "24%"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(targetInfo).collectAddr || _unref(targetInfo).collectLocation ||
          '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, {
            label: "日期",
            width: "24%",
            align: "right"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(targetInfo).created || '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_unref(targetInfo).picInfoVoList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targetInfo).picInfoVoList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "cowItem",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(setPicName(item.picType)), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileIds, (value) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        class: "cowImg",
                        key: value,
                        style: {"width":"100px","height":"100px"},
                        src: getImageUrl(value),
                        fit: "contain",
                        onClick: ($event: any) => (clickImage(_unref(ossUrl) + value.url))
                      }, null, 8, ["src", "onClick"]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              "image-size": 200,
              description: "暂无"
            })),
        (_unref(targetInfo).otherFileInfoVoList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targetInfo).otherFileInfoVoList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "cowItem",
                  key: index
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(otherDetail[item.fileType]), 1),
                    (item.fileType == '0')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileIds, (value) => {
                            return (_openBlock(), _createBlock(_component_el_image, {
                              class: "cowImg",
                              key: value,
                              style: {"width":"100px","height":"100px"},
                              src: getImageUrl(value),
                              fit: "contain",
                              onClick: ($event: any) => (clickImage(getImageUrl(value)))
                            }, null, 8, ["src", "onClick"]))
                          }), 128))
                        ]))
                      : (item.fileType == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileIds, (value) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: value,
                                class: "mr10"
                              }, [
                                _createElementVNode("video", _hoisted_11, [
                                  _createElementVNode("source", {
                                    src: getImageUrl(value),
                                    type: "video/mp4"
                                  }, null, 8, _hoisted_12),
                                  _createTextVNode(" Your browser does not support the video tag. ")
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (showViewer.value)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "hide-on-click-modal": "",
            onClose: _cache[0] || (_cache[0] = () => { previewList.value.value = []; showViewer.value = false }),
            "url-list": previewList.value
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})